import React from 'react';
import { withTranslate } from 'react-redux-multilingual'

// Custom Components
import MainHeader from './common/headers';
import MainFooter from "./common/footers";



// ThemeSettings
import ThemeSettings from "./common/theme-settings"
import { Switch, Route, withRouter } from 'react-router-dom';

// Layouts
import MainHome from './home/mainHome';


//Collection Pages
import Collection from "./collection";
import Category from "./category";
import LookUp from "./search";

// Product Pages
import NoSideBar from "./products";

// Features
import Cart from './cart'
import wishList from './wishlist'
import checkOut from './checkout'
import Payment from './checkout/payment'
// import PaymentLayout from './checkout/payment-layout'
import orderSuccess from './checkout/success-page'
// import Register from './auth/register'
import Logout from "../components/auth/logout"
import Login from '../components/auth/login'
import Update from '../components/auth/login/update';
import UpdateDetail from '../components/auth/login/update_detail';

// Extra Pages
import aboutUs from './pages/about-us'
import PageNotFound from './pages/404'
import lookbook from './pages/lookbook'
import Search from './pages/search'
import Compare from './pages/compare-page'
// import ForgetPassword from './pages/forget-password'
import Contact from './pages/contact'
import Dealership from './pages/registration-page'
import Registration from './pages/registration-enquery'
import RegistrationForm from './pages/registration'
/* import ContactUs from './common/contactUs' */
import Enquiry from './common/enquiry-form'
import Profile from './profile'
import UserInfo from './profile/userInfo'
import AddressInfo from './profile/addressInfo'
import MyOrders from './orders'
import cancelOrder from './cancelOrder';
import ReturnOrders from './returnOrder'
import ReturnCart from './returnOrder/returnCart'
import ChangePassword from './password/changePassword'
import ResetPassword from './password/resetPassword'
import Faq from './pages/faq'

// middlewares
import init from './utils/init';
import ProtectedRoute from './utils/protectedRoute'

// CSA Auth
import ProductSearch from './csaApp/product-search';
import ProductScanner from './csaApp/product-scanner';
import ProductList from './csaApp/product-list';
import ProductAll from './csaApp/product-all';
import Pack from './csaApp/order-pack';
import PackDetail from './csaApp/pack-order-detail';
/* import Test from './csaApp/test'; */
import Ack from './csaApp/order-ackonwledge';
import Awack from './csaApp/owack';
import Payack from './csaApp/ackpick';
import CsaHome from './csaApp/home';
import ConsumerDetails from './csaApp/consumer';
import OrderHome from './csaApp/order-home'
/* import orderWaitingAck from './orderFullfillment/orderWaitingAck' */

//common pages
 import AboutAll from './common/about-us' 
import About from './pages/about'

class App extends React.Component {
    constructor(props) {
      super(props);
      this.idleTimeout = null;
    }
  
    resetIdleTimeout = () => {
      clearTimeout(this.idleTimeout);
  
      this.idleTimeout = setTimeout(() => {
        console.log('User is idle');
        this.props.history.push('/logout');
      }, 1000 * 60 * 15); // 30 seconds 
    };
  
    handleUserActivity = () => {
      this.resetIdleTimeout();
    };
    handleBeforeUnload = () => {
      alert('closing')
      console.log('User is closing the browser. Perform logout or cleanup.');
    };
  
    componentDidMount() {
      const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
  
      events.forEach(event => {
        document.addEventListener(event, this.handleUserActivity);
      });
      window.addEventListener('beforeunload', this.handleBeforeUnload);
      


    }
    refreshCacheAndReload = () => {
      // this.props.history.push('/logout');
    if ('caches' in window) {
      // 1. Get all cache keys
      caches.keys().then((names) => {
        // 2. Delete every cache entry found
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
    
    // 3. Clear local/session storage if needed
    // localStorage.clear();
    // sessionStorage.clear();

    // 4. Force a hard reload from the server (bypassing browser cache)
    window.location.reload(true);
  };

  componentDidMount() {
    // Fires on refresh, tab close, browser close
    window.addEventListener("beforeunload", this.refreshCacheAndReload);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.refreshCacheAndReload);
  }
  
    componentWillUnmount() {
      const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
  
      events.forEach(event => {
        document.removeEventListener(event, this.handleUserActivity);
      });
  
      clearTimeout(this.idleTimeout);
      console.log('inside will unmount')
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    } 


    render() {
        const { stylesheet_properties, themeColor } = this.props;
        console.warn = () => {};
console.error = () => {};   
        return (
            
            <div className={themeColor === "Dark" ? "dark top_body" : 'top_body'} style={{ '--text-color':stylesheet_properties && stylesheet_properties.APS_TOP_BAR_DARK_COLOR_CODE, '--body-background-color': '#fff', '--theme-color':stylesheet_properties && stylesheet_properties.APS_TOP_BAR_COLOR_CODE}}>
               { this.props.location.pathname!=='/compare' ? <MainHeader/>:null}
               

                <Switch>
                <Route exact path={`/compare`} component={Compare}  />

                    <Route exact path={`/`} component={ MainHome } />
                    {/*Routes For Features Product Collection */}
                    <Route exact path={`/CO/:ids/:id`} component={Collection} />
                    <Route exact path={`/MH/:ids/:id`} component={Category} />
                    <Route exact path={`/search`} component={LookUp} />
                    {/*Routes For Single Product*/}
                    <Route exact path={`/PD/:id`} component={NoSideBar} />

                    {/*Routes For custom Features*/}
                    <ProtectedRoute exact path={`/cart`} component={Cart} />
                    <ProtectedRoute exact path={`/wishlist`} component={wishList} />
                    <ProtectedRoute exact path={`/checkout`} component={checkOut} />
                    <ProtectedRoute exact path={`/payment`} component={Payment} />
                    <ProtectedRoute exact path={`/checkout/order-success`} component={orderSuccess} />
                    <ProtectedRoute exact path={`/profile`} component={Profile} />
                    <ProtectedRoute exact path={`/profile/edit-user`} component={UserInfo} />
                    {/* <ProtectedRoute exact path={`/checkout/payment-layout`} component={PaymentLayout} /> */}
                    <ProtectedRoute exact path={`/profile/edit-address`} component={AddressInfo} />
                    <ProtectedRoute exact path={`/profile/my-orders`} component={MyOrders} />
                    <ProtectedRoute exact path={`/profile/cancel-order`} component={cancelOrder} />
                    <ProtectedRoute exact path={`/profile/return-orders`} component={ReturnOrders} />
                    <ProtectedRoute exact path={`/profile/return-cart`} component={ReturnCart} />
                    <Route exact path={`/profile/change-password`} component={ChangePassword} />

                     {/* Routes for CSA App */}
                     <Route exact path={`/csa-search`} component={ProductSearch} />
                     <ProtectedRoute exact path={`/csa-scanner`} component={ProductScanner} />
                     <ProtectedRoute exact path={`/csa-products`} component={ProductList} />
                     <ProtectedRoute exact path={`/csa-productsAll`} component={ProductAll} />
                     <ProtectedRoute exact path={`/csa-home`} component={CsaHome} />
                     <ProtectedRoute exact path={`/csa-consumer`} component={ConsumerDetails} />
                     <ProtectedRoute exact path={`/csa-orderhome`} component={OrderHome} />


                     {/* <Route exact path={`/csa-ack`} component={orderWaitingAck}/>  */}
                     <ProtectedRoute exact path={`/ack`} component={Ack}/> 
                     <ProtectedRoute exact path={`/pack`} component={Pack}/> 
                     <ProtectedRoute exact path={`/packdetail`} component={PackDetail}/> 
                     {/* <Route exact path={`/test`} component={Test}/>  */}
                     <ProtectedRoute exact path={`/awack`} component={Awack}/> 
                     <ProtectedRoute exact path={`/ackpick`} component={Payack}/> 

                     <Route exact path={`/aboutall`} component={AboutAll}/>
                     <Route exact path={`/about`} component={About}/>
                     
                      {/* <Route extact path={`/contactus`} component={ContactUs}/> */}
                     <Route extact path={`/enquiry`} component={Enquiry}/> 


                    {/*Routes For Extra Pages*/}
                    <Route exact path={`/about-us`} component={aboutUs} />
                    <Route exact path={`/404`} component={PageNotFound} />
                    <Route exact path={`/lookbook`} component={lookbook} />
                    <Route exact path={`/login`} component={Login} />
                    <Route exact path={`/update`} component={Update} />
                    <Route exact path={`/uds`} component={UpdateDetail} />
                    
                    <Route exact path={`/logout`} component={Logout} />
                    <Route exact path={`/search`} component={Search} />
                   
                    <Route exact path={`/contact`} component={Contact} />
                    <Route exact path={`/dealership`} component={Dealership} />
                    <Route exact path={`/registration`} component={Registration} />     
                    <Route exact path={`/registration-form`} component={RegistrationForm} />     
                    <Route exact path={`/reset-password`} component={ResetPassword} />
                    <Route exact path={`/faq/:id`} component={Faq} />
                    <Route component={PageNotFound} />
                </Switch>
                { <>{this.props.location.pathname!=='/compare' ? <MainFooter />: null }<ThemeSettings /> </> }
                
            </div>
        );
    }
}

export default withTranslate(withRouter(init(App)));

